// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"affix-buttons_wrapper__3RrWY"};